import Vue from 'vue'
import Router, { Route, Next } from 'vue-router'
import VueCookies from 'vue-cookies'

import routes from '@/config/routes'

Vue.use(Router)

const index = new Router({
  routes: routes,
})

export default index
